import styled from '@emotion/styled';
import { MEDIA_QUERY } from '@zola/zola-ui/src/styles/emotion';
import { Caption } from 'components/util/VideoSnippet/VideoSnippet.styles';

export const Container = styled.div<{ fontFamily?: string; fontColor?: string }>`
  margin-top: 80px;
  padding-bottom: 100px;
  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    padding-bottom: 40px;
  }
  > div:not(:first-of-type) {
    margin-top: 100px;
  }

  ${Caption} {
    font-family: ${({ fontFamily }) => fontFamily};
    color: #${({ fontColor }) => fontColor};
  }
`;
